import { defineComponent as _defineComponent } from 'vue'
import {computed, ref, watch} from "vue";
import PrimeDropdown from "@/components/forms/dropdown/themed/PrimeDropdown.vue";
import {useRequest} from "vue-request";
import {
  fetchEpayIndiaBanks, fetchEpayIndonesiaBanks,
} from "capitalist-shared/src/finance/epay/epay";


export default /*#__PURE__*/_defineComponent({
  __name: 'EpayBankOptions',
  props: {
  value: {
    type: String,
    required: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  country: {
    type: String,
    default: 'india'
  }
},
  emits: ['input', 'selected'],
  setup(__props, { emit: emits }) {

const props = __props;



const config = {
  india: {
    url: '/webapi/finance/epy/indiaBanks',
    fetcher: fetchEpayIndiaBanks
  },
  indonesia: {
    url: '/webapi/finance/epy/indonesiaBanks',
    fetcher: fetchEpayIndonesiaBanks
  }
}

const activeConfig = computed(() => {
  return config[props.country] || config.india;
})

const pagesize = ref(300);
const page = ref(0);
const search = ref('');

const bankListData = useRequest(() => activeConfig.value.fetcher(search.value, page.value, pagesize.value), {
  cacheKey: () => {
    return [activeConfig.value.url, page.value, search.value, pagesize.value].join('-');
  },
  refreshDeps: [search, page, pagesize],
  cacheTime: 600000,
  errorRetryCount: 6,
  errorRetryInterval: 3000,
  // pollingInterval: 600000,
  debounceInterval: 300,
})



const isSelectDisabled = computed(() => {
  return props.disabled || bankListData.loading?.value;
})

const options = computed(() => {
  return (bankListData.data.value?.banks || []).map((option, idx) => {
    return {
      ...option,
      keyIdx: [idx, option.bankId, option.locationId, option.bankName].join('-'),
    }
  });
})

const val = computed({
  get: () => props.value,
  set: (value) => emits('input', value)
})

const selectedOption = computed(() => {
  if (!val.value) return null;
  return options.value.find((option) => option.locationId === val.value);
})

watch(selectedOption, (v) => {
  emits('selected', v)
})

return { __sfc: true,props, config, activeConfig, pagesize, page, search, bankListData, emits, isSelectDisabled, options, val, selectedOption, PrimeDropdown }
}

})